import * as PlanDetailsUI from '../PlanDetailsUI';
import React from 'react';
import { PlanActions } from '../PlanActions';
import { globalFormat } from '../../../../utils/formatting';
import { Currency } from '../../../../utils/apollo/graphqlSchema';

interface IProps {
  customerName: string;
}

const NoPlan = ({ customerName }: IProps) => {
  const { locale } = globalFormat.getGlobalFormat();
  return (
    <PlanDetailsUI.Details>
      <PlanDetailsUI.Header>
        <PlanDetailsUI.Title>Kubit Plan</PlanDetailsUI.Title>
        <PlanDetailsUI.CustomerName>{customerName}</PlanDetailsUI.CustomerName>
      </PlanDetailsUI.Header>
      <PlanDetailsUI.PlanHighlights>
        <PlanDetailsUI.PlanHighlight>
          <PlanDetailsUI.PlanHighlightTitle>
            Annual MTU allotment
          </PlanDetailsUI.PlanHighlightTitle>
          <PlanDetailsUI.PlanHighlightContent>
            N/A
          </PlanDetailsUI.PlanHighlightContent>
        </PlanDetailsUI.PlanHighlight>
        <PlanDetailsUI.PlanHighlight>
          <PlanDetailsUI.PlanHighlightTitle>
            Overage charge
          </PlanDetailsUI.PlanHighlightTitle>
          <PlanDetailsUI.PlanHighlightContent>
            {globalFormat.formatCurrency({
              value: 0,
              locale,
              currency: Currency.Usd,
            })}
          </PlanDetailsUI.PlanHighlightContent>
        </PlanDetailsUI.PlanHighlight>
      </PlanDetailsUI.PlanHighlights>
      <PlanActions />
    </PlanDetailsUI.Details>
  );
};

export default NoPlan;
